import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';

class TrainingMattersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      matter_id: null,
      lista_materias: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarMateria = this.adicionarMateria.bind(this);
    this.deletar = this.deletar.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      training_id: newProps.training_id,
      training_hours_total: newProps.training_hours_total,
    });
    if(Array.isArray(newProps.materias) && Array.isArray(newProps.lista_materias)) {
      this.setState({dados: newProps.materias, lista_materias: newProps.lista_materias});
    }
  }

  adicionarMateria(event) {
    event.preventDefault();
    var datasave = {
      matter_id: this.state.matter_id,
      training_id: this.props.training_id,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/materia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/treinamento/materia//"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var training_matter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa matéria?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/materia/' + training_matter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarMateria}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Matérias{/*" / Total de horas: " + this.state.training_hours_total*/}</label>
            <Select
              className="form-field-name"
              name="matter_id"
              value={this.state.matter_id}
              searchable={true}
              placeholder={'Selecionar matérias'}
              onChange={this.handleSelectChange.bind(this, 'matter_id')}
              options={this.state.lista_materias}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar materia</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há materias cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="materia" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>materia</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default TrainingMattersTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingMattersTab.js